module.exports = __webpack_public_path__ + "static/media/mini.b88051d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程E200厢式车/mini.png
// module id = 711
// module chunks = 0